import React from 'react';
import { useIntl } from 'react-intl-next';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { SyncBlocksIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import { canBeConvertedToSyncBlock } from '../pm-plugins/utils/utils';
export var CreateSyncedBlockDropdownItem = function CreateSyncedBlockDropdownItem(_ref) {
  var _api$selection;
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState) === null || _api$selection === void 0 || (_api$selection = _api$selection.currentState()) === null || _api$selection === void 0 ? void 0 : _api$selection.selection;
  var canCreateSyncBlock = selection && canBeConvertedToSyncBlock(selection);
  if (!canCreateSyncBlock) {
    return null;
  }
  var onClick = function onClick() {
    var _api$core, _api$core2;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(function (_ref2) {
      var _api$blockControls;
      var tr = _ref2.tr;
      api === null || api === void 0 || api.syncedBlock.commands.insertSyncedBlock()({
        tr: tr
      });
      api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.toggleBlockMenu({
        closeMenu: true
      })({
        tr: tr
      });
      return tr;
    });
    api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(SyncBlocksIcon, {
      label: ""
    }),
    onClick: onClick
  }, selection !== null && selection !== void 0 && selection.empty ? formatMessage(blockMenuMessages.createSyncedBlock) : formatMessage(blockMenuMessages.convertToSyncedBlock));
};